import ScrollBar from 'react-perfect-scrollbar'
import 'react-perfect-scrollbar/dist/css/styles.css'
import './index.less'

export default ScrollBar



// WEBPACK FOOTER //
// ./src/components/ScrollBar/index.js